import Avvir from "avvir";

import getTradesByCode from "../../../services/getters/trade_getters/get_trades_by_code";
import tradesLoaded, { TradesLoadedEvent } from "../../../events/loaded/trade/trades_loaded";

import type { AvvirAsyncThunk } from "../../make_eventful_action";

const loadTrades = (projectId: string): AvvirAsyncThunk<typeof getTradesByCode, TradesLoadedEvent> => {
  return (dispatch, getState) => {
    const user = getState().user;

    return Avvir.api.trades.listTrades({ projectId }, user).then(trades => {
      dispatch(tradesLoaded(projectId, trades));
      return getTradesByCode(getState(), { projectId });
    });
  };
};

export default loadTrades;
